import { createReducer, on } from "@ngrx/store";
import { PtrsActions } from "../actions";
import { PtrsInfo } from "../models/ptrs/PtrsInfo";
import { individual } from "../models/ptrs/PaidFor";
import { InitReleaseActions } from "../../initiate-and-release/actions";

export const ptrsInfoKey = 'ptrsInfo';

export interface State extends PtrsInfo {
};

export const initialPtrsInfoState: PtrsInfo = {
    balances: {
        income: '',
        principal: '',
        hasError: false,
        notFound: false
    },
    overdraftRules: {
        piCode: '',
        allowPrincipalOverdraft: false,
        allowIncomeOverdraft: false,
        allowManualOverride: false,
        hasError: false,
        notFound: false
    },
    paidFor: {
        individuals: [
            {
                name: '',
                role: '',
                id: 0
            }
        ] as [individual],
        hasError: false,        
    },
    loading: false,
    error: '',
    hasError: false,
    ptrsCallFinished : false
}

export const reducer = createReducer(
    initialPtrsInfoState,
    on(PtrsActions.callPtrs, (state) => {
        return {
            ...state,
            balances: {
                income: '',
                principal: '',
                hasError: false,
                notFound: false
            },
            overdraftRules: {
                piCode: '',
                allowPrincipalOverdraft: false,
                allowIncomeOverdraft: false,
                allowManualOverride: false,
                hasError: false,
                notFound: false
            },
            paidFor: {
                individuals: [
                    {
                        name: 'Paid For The Trust',
                        role: 'Owner',
                        id: -1
                    }
                ] as [individual],
                hasError: false,        
            },
            loading: true,
            error: '',
            hasError: false,
            ptrsCallFinished: false
        }
    }),
    on(PtrsActions.callPtrsSuccess, (state, response) => {
        return {
            ...state,
            balances: response.balances,
            overdraftRules: response.overdraftRules,
            paidFor: response.paidFor,
            loading: false,
            ptrsCallFinished: true,
            error: '',
            hasError: false
        }
    }),    
    on(PtrsActions.callPtrsFailure, (state, error) => {
        return {
            ...state,
            paidFor: {
                individuals: [
                    {
                        name: 'Paid For The Trust',
                        role: 'Owner',
                        id: -1
                    }
                ] as [individual],
                hasError: true,        
            },
            loading: false,
            error: error.message,
            hasError: true,
            ptrsCallFinished: true
        }
    }),
    on(InitReleaseActions.initReleaseByDraftIdSuccessful, (state, {response}) => {
        if (!response.accountData?.isTrust || !response.draftObject?.paidFor) return state;
        return {
            ...state,
            paidFor: {
                ...state.paidFor,
                individuals: [
                    response.draftObject.paidFor
                ] as [individual]
            }
        }
    })
)